var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import Modal from '@/components/Modal.vue';
import AccountManagementNavbarContainer from '@/modules/admin/containers/AccountManagementModal/AccountManagementNavbar.container.vue';
import AccountManagementMainContainer from '@/modules/admin/containers/AccountManagementModal/AccountManagementMain.container.vue';
import AccountManagementRightDrawer from '@/modules/admin/components/AccountManagementModal/AccountManagementRightDrawer.vue';
let AccountManagementModalContainer = class AccountManagementModalContainer extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
    }
    async created() {
        this.initData();
    }
    closeModal() {
        this.showModal = false;
        this.$store.dispatch('admin/update_right_tab_of_modal', null);
        this.$emit('closeModal');
    }
    closeRightDrawer() {
        this.$store.dispatch('admin/update_right_tab_of_modal', null);
    }
    async initData() {
        this.loading = true;
        await this.$store.dispatch('admin/fetch_account_info', {
            accountId: this.user.account_id,
        });
        this.loading = false;
    }
    get accountInfo() {
        return this.$store.getters['admin/get_selected_account_info'];
    }
    get rightTabOfModal() {
        return this.$store.getters['admin/get_right_tab_of_modal'];
    }
};
__decorate([
    PropSync('open', { default: false })
], AccountManagementModalContainer.prototype, "showModal", void 0);
__decorate([
    Prop({ default: () => { } })
], AccountManagementModalContainer.prototype, "user", void 0);
AccountManagementModalContainer = __decorate([
    Component({
        name: 'AccountManagementModalContainer',
        components: {
            Modal,
            AccountManagementNavbarContainer,
            AccountManagementMainContainer,
            AccountManagementRightDrawer,
        },
    })
], AccountManagementModalContainer);
export default AccountManagementModalContainer;
